import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import Linkify from 'linkify-react';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import remarkGemoji from 'remark-gemoji';

const linkifyOptions = {
  target: '_blank',
  rel: 'noopener noreferrer',
  ignoreTags: ['a'],
};

const withLinkify = (Tag) => ({ children, ...props }) => (
  <Tag {...props}>
    <Linkify options={linkifyOptions}>{children}</Linkify>
  </Tag>
);

const components = {
  p: withLinkify('p'),
  li: withLinkify('li'),
  td: withLinkify('td'),
  th: withLinkify('th'),
  h1: withLinkify('h1'),
  h2: withLinkify('h2'),
  h3: withLinkify('h3'),
  h4: withLinkify('h4'),
  h5: withLinkify('h5'),
  h6: withLinkify('h6'),
  a: ({ children, href, ...props }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
      {children}
    </a>
  ),
};

// remarkBreaks → classic Redcarpet `hard_wrap`; remarkGfm → `strikethrough` + `autolink`;
// remarkGemoji → classic `md_emoji` gem (`:smile:` shortcodes). Together these reproduce the
// pre-migration `markdown()` helper's behavior for exact parity (eng-maintenance#21234).
const remarkPlugins = [remarkBreaks, remarkGfm, remarkGemoji];

export default function Markdown(props) {
  const { children } = props;

  return (
    <ReactMarkdown remarkPlugins={remarkPlugins} components={components}>
      {children}
    </ReactMarkdown>
  );
}

Markdown.propTypes = {
  children: PropTypes.string,
};
